/* -------------------------------------------------------------------------- */
/*                                Functions                                   */
/* -------------------------------------------------------------------------- */

import { Organization } from '@global-types/index';

export const filterEntitiesByIDs = (
	Organizations: Organization[],
	OrganizationsByProducerIDs: string[]
) => {
	try {
		const filteredEntities = Organizations.filter(
			(_organization) =>
				OrganizationsByProducerIDs.includes(
					_organization.id
				)
		);
		return filteredEntities;
	} catch (error) {
		console.error(error);
		return [];
	}
};
